import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/index.vue'
import About from '../components/about.vue'
import Footer from '../components/footer.vue'
import News from '../components/news.vue'
import Newsdata from '../components/newsdata.vue'
import Mould from '../components/mould.vue'
import Moulddata from '../components/moulddata.vue'
import Case from '../components/case.vue'
import Casedata from '../components/casedata.vue'
import Serve from '../components/serve.vue'
import Header from '../components/header.vue'
import Upform from '../components/upform.vue'
import Mapbox from '../components/mapbox.vue'

Vue.use(VueRouter)



const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        component: Index
    },
    {
        path: '/about',
        component: About
    },
    {
        path: '/footer',
        component: Footer
    },
    {
        path: '/news',
        component: News
    },
    {
        path: '/newsdata',
        component: Newsdata
    },
    {
        path: '/mould',
        component: Mould
    },
    {
        path: '/moulddata',
        component: Moulddata
    },
    {
        path: '/case',
        component: Case
    },
    {
        path: '/casedata',
        component: Casedata
    },
    {
        path: '/serve',
        component: Serve
    },
    {
        path: '/header',
        component: Header
    },
    {
        path: '/upform',
        component: Upform
    },
    {
        path: '/mapbox',
        component: Mapbox
    }
]

const router = new VueRouter({
    mode: 'history', // 使用 HTML5 History 模式
    routes
})


export default router
